<div class="splash-plyca-screen" rel="preload" aria-hidden="true">
    <div class="splash-plyca-loader"></div>
    <img class="splash-plyca-logo" src="assets/img/plyca.png" rel="preload" alt="" role="presentation">
</div>